import {
  Inventory2,
  PointOfSale,
  RestaurantMenu,
  TableRestaurant,
} from "@mui/icons-material";
import { Box, Divider, Stack, Typography } from "@mui/material";

export default function OnboardingLoginAndRegister() {
  return (
    <Box
      sx={{
        width: { xs: "0%", md: "50%" },
        display: { xs: "none", md: "flex" },
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: "url('/assets/icons/background.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(135deg, rgba(5,20,10,0.85) 0%, #09884b8f 40%, rgba(0,60,20,0.75) 100%)",
          backdropFilter: "blur(4px)",
        },
      }}
    >
      <Stack
        spacing={3}
        alignItems="center"
        sx={{
          position: "relative",
          zIndex: 2,
          p: 4,
          textAlign: "center",
          maxWidth: 420,
        }}
      >
        <img
          src="/assets/icons/logo.png"
          alt="Restaurant Logo"
          style={{
            maxWidth: 250,
            width: 120,
            borderRadius: 24,
            boxShadow: "0 6px 24px rgba(0,255,150,0.15)",
            padding: 8,
            background: "white",
          }}
          draggable={false}
        />

        <Typography
          variant="h4"
          fontWeight={800}
          color="#fff"
          sx={{
            textShadow: "0 3px 10px rgba(0,0,0,0.5)",
            fontFamily: "Montserrat, sans-serif",
          }}
        >
          Bienvenido a BCPOS
        </Typography>

        <Typography
          variant="body1"
          color="rgba(255,255,255,0.85)"
          sx={{
            fontSize: "0.95rem",
            lineHeight: 1.6,
            textAlign: "center",
            mb: 2,
          }}
        >
          Administra tu restaurante de forma ágil y organizada. Controla ventas,
          productos, inventario, mesas y personal desde un solo lugar. Optimiza
          procesos y mejora la operación diaria de tu negocio gastronómico.
        </Typography>

        <Divider
          sx={{
            width: "40%",
            borderColor: "rgba(255,255,255,0.2)",
            mb: 1,
          }}
        />

        <Stack
          direction="row"
          spacing={3}
          justifyContent="center"
          sx={{ mt: 1, color: "rgba(255,255,255,0.9)" }}
        >
          <Stack alignItems="center" spacing={0.5}>
            <RestaurantMenu sx={{ fontSize: 30, color: "#00e677b2" }} />
            <Typography variant="caption" color="rgba(255,255,255,0.8)">
              Menú
            </Typography>
          </Stack>

          <Stack alignItems="center" spacing={0.5}>
            <Inventory2 sx={{ fontSize: 30, color: "#00e677b2" }} />
            <Typography variant="caption" color="rgba(255,255,255,0.8)">
              Inventario
            </Typography>
          </Stack>

          <Stack alignItems="center" spacing={0.5}>
            <PointOfSale sx={{ fontSize: 30, color: "#00e677b2" }} />
            <Typography variant="caption" color="rgba(255,255,255,0.8)">
              Ventas
            </Typography>
          </Stack>

          <Stack alignItems="center" spacing={0.5}>
            <TableRestaurant sx={{ fontSize: 30, color: "#00e677b2" }} />
            <Typography variant="caption" color="rgba(255,255,255,0.8)">
              Mesas
            </Typography>
          </Stack>
        </Stack>

        <Typography
          variant="body2"
          sx={{
            mt: 3,
            color: "rgba(255,255,255,0.6)",
            fontStyle: "italic",
            letterSpacing: 0.5,
          }}
        >
          “La administración perfecta empieza hoy 🍽️”
        </Typography>
      </Stack>
    </Box>
  );
}
